<template>
  <div class="pr-2 pt-2">
    <div class="pointer-events-none relative z-0 size-full" @mouseover="hovering = true" @mouseleave="hovering = false">
      <NuxtLink class="pointer-events-auto absolute inset-0 z-[-1] block" :to="props.product.productUri" :title="props.product.name" @click="sendGtmProductClick">
        <span class="sr-only">{{ props.product.name }}</span>
      </NuxtLink>

      <WishlistButton
        :id="props.product.id"
        class="btn-medium pointer-events-auto absolute -right-2 -top-2 block size-9"
        :option-ids="[]"
        :is-added="wishlisted"
        @on-added-to-wishlist="addToWishlist"
        @on-removed-from-wishlist="wishlisted = false"
      />

      <img
        class="aspect-[4/3] h-auto w-full rounded-2xl"
        :src="hovering && props.product.image2Url ? props.product.image2Url : props.product.imageUrl"
        :alt="props.product.name"
        loading="lazy"
        decoding="async"
      />

      <div class="py-3 text-center text-base">{{ props.product.name }}</div>

      <div class="flex flex-wrap items-baseline justify-center gap-2">
        <template v-if="props.product.discountPrice">
          <Price class="text-text-light line-through" :amount="props.product.regularPrice" exact large-fractional />
          <Price class="text-lg2 font-medium" :amount="props.product.discountPrice" exact />
        </template>
        <Price v-else class="text-lg2 font-medium" :amount="props.product.regularPrice" exact />
      </div>

      <ProductOptions v-if="props.product.options" :product-options="props.product.options" :product-id="props.product.id" lazy-loaded class="mt-4" />
    </div>
  </div>
</template>

<script setup lang="ts">
import Price from '~/components/price/Price.vue'
import WishlistButton from '~/components/wishlist-button/WishlistButton.vue'

import ProductOptions from '~/components/product-grid/ProductOptions.vue'
import type { TiedProductsCardProduct } from './tied-products'

const { proxy: gtmProxy } = useGtm()

const props = defineProps<{
  product: TiedProductsCardProduct
  index: number
  list: string
}>()

const wishlisted = ref(props.product.wishlisted)

const hovering = ref<boolean>(false)

const addToWishlist = () => {
  wishlisted.value = true
  sendGtmAddToWishlistEvent()
}

const sendGtmAddToWishlistEvent = () => {
  gtmProxy.dataLayer.push({
    event: 'addToWishlist',
    ecommerce: {
      currencyCode: useCurrencyCode(),
      add: {
        products: [
          {
            name: props.product.name,
            id: props.product.id,
            price: props.product.discountPrice ? props.product.discountPrice : props.product.regularPrice,
          },
        ],
      },
    },
  })
}

const sendGtmProductClick = () => {
  gtmProxy.dataLayer.push({
    event: 'productClick',
    ecommerce: {
      click: {
        actionField: { list: props.list },
        products: [
          {
            name: props.product.name,
            id: props.product.id,
            position: props.index + 1,
          },
        ],
      },
    },
  })
}
</script>
